import React from 'react'

interface Props {
  translate: (key: string) => string
}

const UploadCensusInstructions: React.FC<Props> = ({ translate }) => {
  return (
    <div className="ml-16 mt-16">
      <span className="color-gray-8">{translate('prospect-signup.step-3.formatting-instructions')}</span> <br />
      <ul>
        {Array.from(Array(6), (e, i) => {
          return (
            <li>
              <span className="color-gray-8">{translate(`prospect-signup.step-3.instruction-${i + 1}`)}</span>
            </li>
          )
        })}
      </ul>
      <span className="color-gray-8">{translate('prospect-signup.step-3.pull-down-menus')}</span> <br />
    </div>
  )
}

export default UploadCensusInstructions
